import { usePortalDoCliente } from '../hooks/acessosExternos';

/** Página inicial do portal do cliente (change `acesso-gestor-cliente`). */
export default function PortalClienteInicioPage() {
  const portal = usePortalDoCliente();
  if (portal.isLoading) return <p className="text-sm text-gray-500">Carregando…</p>;
  if (portal.isError || !portal.data) return <p className="text-sm text-red-600">Não foi possível carregar o portal.</p>;
  const { user, client } = portal.data;
  return (
    <div className="max-w-3xl space-y-4">
      <h1 className="text-2xl font-bold text-gray-900">Olá, {user.name.split(' ')[0]}</h1>
      <section className="rounded-lg border border-gray-200 bg-white p-4 text-sm">
        <p className="text-gray-500">Você está acessando como</p>
        <p className="text-lg font-semibold text-gray-900">{client.tradeName || client.corporateName}</p>
        <p className="text-gray-600">{client.corporateName} · código {client.code}</p>
      </section>
      <p className="text-sm text-gray-600">
        Por aqui você acompanha as informações que a empresa compartilha com o seu time. Novas consultas aparecem no menu acima
        conforme forem liberadas.
      </p>
    </div>
  );
}
